const { Slide } = require("@material-ui/core");
const { forwardRef } = require("react");

const DialogCloseTransition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
})

export { DialogCloseTransition }